module.exports = __webpack_public_path__ + "img/20200507_140947.5a45d23e.jpg";